// 1. First, add this CSS to your theme's main CSS file or in a <style> tag
const popupCSS = `
.cart-popup {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #28a745;
  color: white;
  padding: 15px 20px;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 9999;
  font-family: Arial, sans-serif;
  font-size: 14px;
  transform: translateX(100%);
  transition: transform 0.3s ease;
}

.cart-popup.show {
  transform: translateX(0);
}

.cart-popup-close {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  float: right;
  margin-left: 10px;
}
`;

// 2. Add the CSS to the page
const style = document.createElement('style');
style.textContent = popupCSS;
document.head.appendChild(style);

// 3. Function to show the popup
function showCartPopup() {
  // Remove existing popup if any
  const existingPopup = document.querySelector('.cart-popup');
  if (existingPopup) {
    existingPopup.remove();
  }

  // Create new popup
  const popup = document.createElement('div');
  popup.className = 'cart-popup';
  popup.innerHTML = `
    <span>Erfolgreich zum Warenkorb hinzugefügt</span>
    <button class="cart-popup-close" onclick="this.parentElement.remove()">×</button>
  `;

  // Add to page
  document.body.appendChild(popup);

  // Show popup with animation
  setTimeout(() => {
    popup.classList.add('show');
  }, 1000);

  // Auto-hide after 3 seconds
  setTimeout(() => {
    if (popup.parentElement) {
      popup.classList.remove('show');
      setTimeout(() => {
        if (popup.parentElement) {
          popup.remove();
        }
      }, 300);
    }
  }, 3000);
}

// 4. Override the default add to cart behavior
function initializeCartPopup() {
  // Method 1: For standard Shopify forms - using capture phase to ensure we catch it first
  const addToCartForms = document.querySelectorAll('form[action*="/cart/add"]');
  
  addToCartForms.forEach(form => {
    // Remove any existing event listeners first
    form.removeEventListener('submit', handleFormSubmit);
    
    // Add our event listener in the capture phase (true parameter)
    form.addEventListener('submit', handleFormSubmit, true);
    
    // Also change the form action to prevent default behavior
    form.setAttribute('data-original-action', form.action);
    form.action = 'javascript:void(0);';
  });

  // Method 2: For Ajax add to cart buttons (including quick-add)
  const addToCartButtons = document.querySelectorAll(`
    .btn-add-to-cart, 
    [data-add-to-cart], 
    .quick-add-btn,
    .quick-add-button,
    .quick-add,
    [data-quick-add],
    .product-form__cart-submit,
    .btn-product-add,
    .add-to-cart-btn,
    input[type="submit"][value*="Add"],
    input[type="submit"][value*="cart"],
    button[type="submit"],
    button[name="add"],
    .shopify-payment-button__button,
    [data-testid="add-to-cart"]
  `);
  
  addToCartButtons.forEach(button => {
    const form = button.closest('form');
    if (form && (form.getAttribute('action') || '').includes('/cart/add')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        handleAddToCart(form);
      }, true);
    }
  });

  // Method 3: Event delegation for dynamically loaded quick-add buttons
  document.addEventListener('click', function(e) {
    // Check if clicked element or its parents match quick-add patterns
    const clickedElement = e.target.closest(`
      .quick-add-btn,
      .quick-add-button,
      .quick-add,
      [data-quick-add],
      .product-card__quick-add,
      .card__quick-add,
      .quick-shop-btn,
      [class*="quick-add"],
      [data-action="add-to-cart"]
    `);
    
    if (clickedElement) {
      const form = clickedElement.closest('form');
      if (form && (form.getAttribute('action') || '').includes('/cart/add')) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        handleAddToCart(form);
      }
    }
  }, true);
}

// Separate function to handle form submission
function handleFormSubmit(e) {
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  
  const form = e.target;
  handleAddToCart(form);
  
  return false;
}

// Function to handle the actual add to cart logic
function handleAddToCart(form) {
  const formData = new FormData(form);
  
  fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(data => {
    if (data.status !== 422) {
      showCartPopup();
      updateCartCount();
    } else {
      alert('Fehler beim Hinzufügen zum Warenkorb');
    }
  })
  .catch(error => {
    console.error('Error:', error);
    alert('Fehler beim Hinzufügen zum Warenkorb');
  });
}

// 5. Function to update cart count (optional)
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// 6. Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  initializeCartPopup();
});

// 7. For themes that load content dynamically, you might also need:
document.addEventListener('shopify:section:load', function() {
  initializeCartPopup();
});

// IMPLEMENTATION OPTIONS:

// Option 1: Add this script tag to your theme.liquid file (recommended)
// <script src="{{ 'cart-popup.js' | asset_url }}" defer></script>

// Option 2: Or use async
// <script src="{{ 'cart-popup.js' | asset_url }}" async></script>

// Option 3: Or embed directly in theme.liquid within <script> tags
// Just copy the entire JavaScript code above and paste it between <script></script> tags